interface IConditionalLink {
  children: React.ReactNode;
  condition: boolean;
  href?: string;
  onClick?: () => void;
  [x: string]: unknown;
}

const ConditionalLink: React.FC<IConditionalLink> = ({
  children,
  condition,
  href,
  onClick,
  ...rest
}) => {
  if (condition) {
    return (
      <a href={href} {...(onClick && { onClick: onClick })} {...rest}>
        {children}
      </a>
    );
  }

  return <div {...rest}>{children}</div>;
};

export default ConditionalLink;
